
import { Component, Vue } from "vue-property-decorator";
import LoginModel from "@/models/LoginModel";
import User from "@/models/User";
import LoginService from "@/services/LoginService";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import IframeCommunicatorService, {
  InterPagesMessages,
  MessageTypes,
} from "@/services/IframeCommunicatorService";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import { Getter } from "vuex-class";
import GlobalConfig from "@/GlobalConfig";
import { newGuid } from "@microsoft/applicationinsights-core-js";

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class Login extends Vue {
  public currentYear = new Date().getFullYear();
  public loginModel = new LoginModel();
  public loginService = new LoginService();
  public loading = false;
  public showComunicationError = false;
  public showLoginError = false;
  public loginMessage = "";
  public iframeService = new IframeCommunicatorService();
  public userIsLoggedIn = false;
  @Getter("user") user: User;

  mounted() {
    var html = document.getElementsByTagName("html");
    for (var i = 0; i < html.length; i++) {
      html[i].style.overflow = "visible";
    }
    this.userIsLoggedIn = this.$route.query.invalidUser === "true";
  }
  public goRecuperarClave() {
    this.$router.push("/cambio-password");
  }
  public loginUser() {
    (this.$refs.form as VeeValidateForm).validate().then((isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        this.showComunicationError = false;
        this.showLoginError = false;
        let submittedCedula = this.loginModel.userIdentity;
        let submittedPassword = this.loginModel.password;
        let sessionId = this.$route.query.sessionId
          ? (this.$route.query.sessionId as string)
          : this.uuidv4();
        this.loginModel.sessionId = sessionId;

        this.loginService
          .login(this.loginModel)
          .then(async (response) => {
            if (response.data.respCode == 200) {
              var user = response.data.entity;
              user.cedula = submittedCedula;
              user.password = this.loginModel.password;
              this.$store.dispatch("setUserLoggedAction", user);

              this.$store.dispatch("setSessionId", sessionId);

              var redirectObj = this.applyRedirect(user.esAfiliado);

              if (user.esAfiliado) {
                // var userJson = JSON.stringify({
                //   username: submittedCedula,
                //   password: submittedPassword,
                //   redirectUrl: redirectObj.redirectUrl,
                //   isLocalRedirect: redirectObj.isLocalRedirect,
                // });
                // var jsonEncoded = btoa(userJson);
                // this.iframeService.postMessageToParent(
                //   new InterPagesMessages(
                //     MessageTypes.AfiliadoSignIn,
                //     jsonEncoded
                //   )
                // );
              } else {
                var userName = user.primerNombre + " " + user.primerApellido;
                var dataNoAfiliadoSignIn = {
                  username: userName,
                  redirectUrl: redirectObj.redirectUrl,
                  isLocalRedirect: redirectObj.isLocalRedirect,
                };
                let dataJson = JSON.stringify(dataNoAfiliadoSignIn);
                var jsonEncoded = btoa(dataJson);
                this.iframeService.postMessageToParent(
                  new InterPagesMessages(
                    MessageTypes.NoAfiliadoSignIn,
                    jsonEncoded
                  )
                );
              }

              // setTimeout(() => {
              //   this.applyRedirect(user.esAfiliado);
              //   //this.loading = false;
              // }, 1850);
              //
            } else if (response.data.respCode == 1001) {
              this.loginMessage =
                "Usuario o contraseña incorrecta, por favor verifique.";
              this.showLoginError = true;
              this.loading = false;
            } else {
              this.showComunicationError = true;
              this.loading = false;
            }
          })
          .catch((e) => {
            console.error(e);
            this.$store.dispatch("setUserLoggedAction", null);
            this.showComunicationError = true;
            this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
  }
  public uuidv4(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  public applyRedirect(
    userEsAfiliado: boolean
  ): {
    redirectUrl: string;
    isLocalRedirect: boolean;
  } {
    var redirectUrl = "";
    var isLocalRedirect = true;
    debugger;
    console.log("es afiliado Login"+userEsAfiliado)
    if(!userEsAfiliado){
      this.$router.push("/solicitudes-beneficiario")
       return { redirectUrl, isLocalRedirect };
    }


    if (this.$route.query.redirectPage) {
      redirectUrl = this.$route.query.redirectPage as string;
      isLocalRedirect = true;
      this.$router.push(redirectUrl);
    }

    
      if (this.$route.query.redirectToSiembra) {
        redirectUrl = this.$route.query.redirectToSiembra as string;
        isLocalRedirect = false;
        this.$router.push(redirectUrl);
      }

      // Si es afiliado y no se especifica ReturnUrl, mandar a default
      if (!redirectUrl) {
        // window.location.href = GlobalConfig.PORTAL_BASE_URL;
        // redirectUrl = "/default.aspx";
        // isLocalRedirect = false;
        this.$router.push("/Dashboard");
      }
     

    redirectUrl = redirectUrl || "/Dashboard";

    return { redirectUrl, isLocalRedirect };
    // if (isLocalRedirect) {
    //   this.$router.push(redirectUrl);
    // } else {
    //   this.iframeService.postMessageToParent(
    //               new InterPagesMessages(
    //                 MessageTypes.Redirect,
    //                 redirectUrl
    //               )
    //             );
    // }
  }
  public redirectHome() {
    window.location.href = GlobalConfig.PUBLIC_WEB_URL;
  }
}
